import { render, staticRenderFns } from "./AttestationPage.vue?vue&type=template&id=4400a675&"
import script from "./AttestationPage.vue?vue&type=script&lang=ts&"
export * from "./AttestationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports